import { ReactNode } from 'react';
import { CodeType } from '../CodeType';
import { BuildCodeParams } from './CodeSample';
import CodeBlock from '../CodeBlock';
import { User } from '../../../interfaces/backend/User';
import { BackendCodeSample, UserObjectStringMap } from './BackendCodeSample';

export default class BackendDotNetSample extends BackendCodeSample {
  name = '.NET';
  language = 'csharp';
  codeType = CodeType.BACKEND;
  tabIcon = '';
  commentChar = '//';

  buildCode({
    environment,
    notification,
    user,
    mergeTags
  }: BuildCodeParams): ReactNode {
    const install = `dotnet add package NotificationAPI --version 0.1.0`;

    if (!environment || !notification) {
      return 'loading';
    }

    const code = `using NotificationApi.Server;
using NotificationApi.Server.Models;

var notificationApi = new NotificationApiServer("${environment.clientId}", "${environment.clientSecret}", false);

var user = new NotificationUser("${user.id}")
{
    Email = "${user.email}",
    TelephoneNumber = "${user.number}" // Replace with your phone number
};

var mergeTags = new Dictionary<string, object>
{
    { "item", "Krabby Patty Burger" },
    { "address", "124 Conch Street" },
    { "orderId", "1234567890" }
};

await notificationApi.Send(new SendNotificationData("${notification.notificationId}", user)
{
    MergeTags = mergeTags
});`;

    return (
      <>
        <CodeBlock language="bash" code={install} />
        <CodeBlock language={this.language} code={code} />
      </>
    );
  }

  buildUserObject(user: User): UserObjectStringMap {
    return {
      id: `id: "${user.id}"`,
      email: `email: "${user.email}"`,
      number: {
        value: `number: "${user.number}"`,
        comment: 'Replace with your phone number'
      }
    };
  }
}
